import { newDate } from '@shared/utils/time';

import { SCHEDULE_ITEM_TYPE } from '@ManagerPortal/utils/schedule/constants';

import { TUnavailability, UnavailabilityItem } from '../../Main/types';

export const unnestAndReverseUnavailabilityList = (
  unavailabilityItems?: Record<number, TUnavailability[]>,
): UnavailabilityItem[] | undefined =>
  unavailabilityItems
    ? Object.entries(unavailabilityItems)
        .flatMap(([key, values]) =>
          values.map((value) => ({
            ...value,
            beginTZ: newDate(value.begin),
            endTZ: newDate(value.end),
            employeeId: parseInt(key),
            componentType: SCHEDULE_ITEM_TYPE.UNAVAILABILITY,
          })),
        )
        .reverse()
    : undefined;
